import { ReactNode } from "react";

const TextContent = ({ children = "" }: { children: ReactNode }) => (
  <p style={{ fontSize: 14, color: "#484a56" }}>{children}</p>
);

export default TextContent;
